<template>
  <div class="overlay">
    <div class="overlay_inner success">
      <p class="note" v-translate>Oznámení bylo úspěšně odesláno</p>
      <div class="new_template">
        <p v-translate>Chcete vytvořit z oznámení novou šablonu?</p>
        <p class="field">
          <text-input id="templateName"
                      v-model="messageParams.name"
                      :required="true"
                      name="templateName"
                      ref="templateNameRef"
                      size="30">
            <translate class="translate">Název šablony</translate>
          </text-input>
        </p>
        <p class="buttons">
          <a class="btn" :title="'Vytvořit šablonu' | translate" @click.stop.prevent="createTemplate" v-translate>Vytvořit šablonu</a>
        </p>
      </div>
      <a class="btn btn_action btn_close" :title="'Zavřít' | translate" @click.stop.prevent="emitClose"
         v-translate>Zavřít</a>
    </div>
  </div>
</template>

<script>

import formFields from "../../../../components/mixins/form-fields"
import detailActions from "../../../../components/mixins/detail-actions"

export default {
  name: "NewMessageSaveAsTemplatePopup",
  components: {},
  mixins: [formFields, detailActions],
  props: {
    messageParams: Object,
  },
  data: function () {
    return {
      entityService: null,
      entity: Object(),
    }
  },
  created: function (MessageTemplateService, OperatorService) {
    this.entityService = MessageTemplateService
    this.operatorService = OperatorService
    this.prepareIdOperator()
  },
  computed: {

  },
  methods: {
    prepareIdOperator() {
      this.entity.id_operator = this.$_loggedUser_selectedOperatorId;
    },
    emitClose() {
      this.$emit('close-popup')
    },
    createTemplate() {
      this.entity.name = this.messageParams.name
      this.entity.force_confirmation = this.messageParams.force_confirmation
      this.entity.time_validity = this.messageParams.time_validity
      this.entity.type = this.messageParams.type
      this.entity.timer = this.messageParams.timer
      this.entity.translations = this.messageParams.translations

      this.entityService.createEntity(this.entity)
          .then(data => {
            this.emptyMessage()
            this.emitClose()
          })
          .catch(function (error) {
            this.setErrorMessage(this.$gettext('Zadejte název'))
          }.bind(this))
    },
    setLoadingMessage() {
      this.$emit('set-loading-message')
    },
    emptyMessage() {
      this.$emit('empty-message')
    },
    setErrorMessage(error) {
      this.$emit('set-error-message', error)
    }
  },
  watch: {
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/messages/popup/NewMessageSaveAsTemplatePopup.vue